import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input
} from "@angular/core";

import { HeaderTab } from "./models";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "ta-header-tabs",
  templateUrl: "header-tabs.template.html"
})
export class HeaderTabsComponent {
  @Input()
  tabs: HeaderTab[];

  @Input()
  activeTab?: HeaderTab;

  constructor(public elementRef: ElementRef) {}

  tabIsActive(tab: HeaderTab): boolean {
    if (this.activeTab == null) {
      return false;
    }

    return tab.path === this.activeTab.path;
  }
}
